module.exports = __webpack_public_path__ + "static/metro_pmt-7dd4501b463f358ceae205c041573730.png";